import React from 'react'
import { Link } from 'react-router-dom'
import { routePaths } from '../urls'
import { useStateValue } from '@State'
import { StatusMarker } from './StatusMarker'

export const Navigation = () => {
  const [state] = useStateValue()
  const { canvasUrl, canvasCoursenum, courseToken, launchToolCreated, selectedLms } = state

  let setupIcon = canvasUrl ? 'fas fa-check' : 'fas fa-exclamation-triangle'
  let authorizeIcon = courseToken ? 'fas fa-check' : 'fas fa-exclamation-triangle'
  let chooseIcon = canvasCoursenum ? 'fas fa-check' : 'fas fa-exclamation-triangle'
  let reviewIcon =
    launchToolCreated === 'true' ? 'fas fa-check' : 'fas fa-exclamation-triangle'

  let navPaths = {
    canvas_v2: [
      {
        icon: setupIcon,
        component: <Link to={routePaths.canvasSetup}>1. Canvas Setup</Link>,
      },
      {
        icon: authorizeIcon,
        component: <Link to={routePaths.canvasAuthorize}>2. Authorize</Link>,
      },
      {
        icon: chooseIcon,
        component: (
          <Link to={routePaths.canvasChooseCourse}>3. Choose Course</Link>
        ),
      },
      {
        icon: reviewIcon,
        component: (
          <Link to={routePaths.canvasCreateTool}>4. Create Link</Link>
        ),
      },
      {
        icon: reviewIcon,
        component: <Link to={routePaths.canvasReview}>5. Review</Link>,
      },
      {
        icon: null,
        component: (
          <Link to={routePaths.canvasOptionalActions}>Optional Actions</Link>
        ),
      },
    ],
    brightspace: [
      {
        icon: authorizeIcon,
        component: (
          <Link to={routePaths.brightspaceSetup}>1. Brightspace Setup</Link>
        ),
      },
      {
        icon: null,
        component: (
          <Link to={routePaths.brightspaceAssessments}>
            2. Choose Assessments
          </Link>
        ),
      },
      {
        icon: null,
        component: (
          <Link to={routePaths.brightspaceTest}>Test Integration</Link>
        ),
      },
    ],
  }

  let pathsList = []
  switch (selectedLms) {
    case 'canvas_v2':
      pathsList = navPaths.canvas_v2
      break
    case 'brightspace':
      pathsList = navPaths.brightspace
      break
  }

  let navItems = pathsList.map((obj, i) => (
    <li className="lms-step" key={i}>
      {obj.component}
      <StatusMarker iconType={obj.icon} />
    </li>
  ))

  return (
    <div
      id="body_section_left_column_inner"
      className="overflow-x-hidden overflow-y-auto"
    >
      <ul>{navItems}</ul>
    </div>
  )
}

